import React, { Component, Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import ReactGA from 'react-ga';
import { withRouter } from 'react-router-dom';

export class PremiumModal extends Component {
    componentDidMount() {
        ReactGA.initialize('UA-122665050-1');
        ReactGA.event({
            category: "Premium Modal",
            label: "Premium Feature Required",
            action: "Feature Locked"
        });
    }

    handleUpgradeClick = () => {
        // Close the modal
        this.props.closeModal();

        // Redirect to premium page
        this.props.history.push('/dashboard/premium');
    };

    render() {
        const { featureName } = this.props;
        const featureText = featureName ? `The ${featureName} feature` : 'This feature';

        return (
            <Transition appear show={true} as={Fragment}>
                <Dialog
                    as="div"
                    className="relative z-[10000]"
                    onClose={this.props.closeModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#0000008a] transition-opacity" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-[#141414] text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                                    <div className="p-6">
                                        <div className="flex flex-col items-center text-center">
                                            <div className="mb-6 rounded-full bg-[#FF4444] p-3">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                                </svg>
                                            </div>

                                            <Dialog.Title
                                                as="h3"
                                                className="text-2xl font-bold text-[#FFFFFF] mb-4"
                                            >
                                                Premium Feature
                                            </Dialog.Title>

                                            <div className="mb-8">
                                                <p className="text-[#9CA3AF] mb-4">
                                                    {featureText} requires a premium subscription.
                                                </p>
                                                <p className="text-[#9CA3AF]">
                                                    Upgrade to premium to unlock all features and take your Discord bot to the next level!
                                                </p>
                                            </div>

                                            <div className="flex gap-3">
                                                <button
                                                    type="button"
                                                    className="px-4 py-2 bg-[#2A2A2A] text-[#FFFFFF] hover:bg-[#374151] rounded-md transition-colors font-medium"
                                                    onClick={this.props.closeModal}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type="button"
                                                    className="px-4 py-2 bg-gradient-to-r from-[#FFD700] to-[#FFA500] text-black hover:from-[#FFA500] hover:to-[#FFD700] rounded-md transition-colors font-medium shadow-lg shadow-[#FFD700]/40"
                                                    onClick={this.handleUpgradeClick}
                                                >
                                                    Upgrade to Premium
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        );
    }
}

export default withRouter(PremiumModal);
